import React from 'react'
import styled, { css } from 'styled-components'

export type OptionButtonProps = React.PropsWithChildren<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    $active?: boolean
    $disabled?: boolean
  }
>
export const OptionButton = styled.button<OptionButtonProps>`
  background-color: #fff;
  border: 1px solid #e5e5e5;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  transition: color 0.3s, opacity 0.3s;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: box-shadow 0.2s;
    box-shadow: inset 0 0 0 0 #cf0000;
  }

  &:hover::after {
    box-shadow: inset 0 0 0 2px #cf0000;
  }

  ${({ $active }) =>
    $active
      ? css`
          &::after,
          &:hover::after {
            box-shadow: inset 0 0 0 4px #cf0000;
          }
        `
      : ''}

  ${({ $disabled }) =>
    $disabled
      ? css`
          opacity: 0.5;
          pointer-events: none;
        `
      : ''}
`
